<template>
    <div v-if="!loading" class="pb-2">
        <validation-observer ref="smsManagementValidation" #default="{ invalid }">
            <b-form @submit.prevent>
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="text-primary mb-2">الگوهای پیامک سیستمی</h3>
                    <b-button @click="smsManagementEdit" :disabled="loadingButton" variant="primary"
                        class="d-flex mb-2">
                        <span>ذخیره تغییرات</span>
                        <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
                <b-row>
                    <b-col xl="6" lg="5" md="12" class="order-2 order-lg-1">
                        <b-card>
                            <b-alert :variant="hasPendingTemplate ? 'warning' : 'success'" show>
                                <p class="alert-body text-center">
                                    وضعیت متن پیامک : {{ hasPendingTemplate ? 'در حال بررسی' : 'تایید شده' }}
                                </p>
                            </b-alert>
                            <b-alert variant="warning" show>
                                <p class="alert-body text-center">
                                    در صورت ویرایش متن پیامک، تا زمان تایید متن جدید توسط تیم پشتیبانی، تمامی پیامک های
                                    شما با
                                    متن
                                    پیشین ارسال خواهد شد.
                                </p>
                            </b-alert>
                            <div v-for="(item, index) in smsManagementData" :key="`smsManagement${index}`"
                                class="mt-2 border-info rounded p-2">
                                <h5 class="font-weight-bolder pl-25">{{ item.name }}</h5>
                                <p class="mb-50 pl-25">{{ item.description }}</p>
                                <b-form-group>
                                    <validation-provider #default="{ errors }" :name="item.name" rules="required">
                                        <b-form-textarea v-model="item.message"
                                            :state="errors.length > 0 ? false : null"
                                            :disabled="item.key == 'CustomerLoginWithOTP'" dir="rtl"
                                            class="text-primary-middle" rows="4" no-resize spellcheck="false" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                    </validation-provider>
                                </b-form-group>
                                <div class="d-flex align-items-center mt-1">
                                    <b-form-checkbox v-model="item.isActive" name="weekly-inventory-schedule" switch>
                                        <div style="font-size: 1rem;">وضعیت پیامک</div>
                                    </b-form-checkbox>
                                </div>
                            </div>
                        </b-card>
                    </b-col>
                    <b-col xl="6" lg="7" md="12" class="order-1 order-lg-2">
                        <b-card no-body class="position-sticky" style="top: 100px;">
                            <b-table responsive :items="Keys" :fields="fields" class="mb-0">
                                <template #cell(value)="data">
                                    <b-badge v-clipboard:copy="data.item.value" v-clipboard:success="onCopy"
                                        variant="light-primary" class="pointer">
                                        {{ data.item.value }}
                                    </b-badge>
                                </template>
                            </b-table>
                        </b-card>
                    </b-col>
                </b-row>
            </b-form>
        </validation-observer>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BForm, BRow, BCol, BButton, BAvatar, BTable, BPagination, BFormInput, BFormGroup, BSpinner, BAlert, BFormCheckbox, BFormTextarea, BBadge } from 'bootstrap-vue';
import { storeService } from '@core/services';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from '@validations';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BAvatar,
        BTable,
        BPagination,
        BFormInput,
        BFormGroup,
        BSpinner,
        BAlert,
        BFormCheckbox,
        BBadge,
        BForm,
        BFormTextarea
    },
    data() {
        return {
            required,
            loading: true,
            loadingButton: false,
            storeId: null,
            hasPendingTemplate: true,
            Keys: [
                { name: 'نام مشتری', value: '{{Customer.FirstName}}' },
                { name: 'نام خانوادگی مشتری', value: '{{Customer.LastName}}' },
                { name: 'شماره اشتراک مشتری', value: '{{Customer.Number}}' },
                { name: 'امتیاز دریافتی مشتری (هر خرید)', value: '{{Order.ReceivedScore}}' },
                { name: 'جمع امتیاز مشتری', value: '{{Customer.Score}}' },
                { name: 'اعتبار دریافتی مشتری (هر خرید)', value: '{{Order.ReceivedCashbackAmount}}' },
                { name: 'جمع اعتبار مشتری', value: '{{Customer.WalletBalance}}' },
                { name: 'نام سطح فعلی مشتری', value: '{{Customer.LevelName}}' },
                { name: 'لینک ثبت نظر', value: '{{Store.CustomerCommentsUrl}}' },
                { name: 'لینک دیجیتالی باشگاه', value: '{{Store.ClubUrl}}' },
                { name: 'لینک مینی وب‌سایت مجموعه', value: '{{Store.ProfileUrl}}' },
                { name: 'نام مجموعه', value: '{{Store.Name}}' },
            ],
            fields: [
                {
                    key: 'value',
                    label: 'کلید',
                },
                {
                    key: 'name',
                    label: 'توضیحات',
                },
            ],
            smsManagementData: [],
        }
    },
    methods: {
        onCopy() {
            this.$notif({ type: 'normal', title: 'کپی کلید با موفقیت انجام شد' });
        },
        smsManagementEdit() {
            this.$refs.smsManagementValidation.validate().then((success) => {
                if (success) {
                    this.loadingButton = true
                    let data = {
                        templates: []
                    }
                    this.smsManagementData.forEach((item) => {
                        data.templates.push({
                            key: item.key,
                            isActive: item.isActive,
                            message: item.message
                        })
                    })
                    storeService.smsManagement(this.storeId, data).then(({ data }) => {
                        this.loadingButton = false
                        this.$notif({ type: 'success', title: 'عملیات با موفقیت انجام شد' });
                        this.getSmsManagement()
                    })
                        .catch((err) => {
                            this.$notif({ type: 'error' });
                            this.loadingButton = false
                        })
                }
            });
        },
        getSmsManagement() {
            storeService.getSmsManagement(this.storeId).then(({ data }) => {
                this.hasPendingTemplate = data.hasPendingTemplate
                this.smsManagementData = []
                this.smsManagementData = data.items.map(item => ({
                    ...item,
                    message: item.customMessage ? item.customMessage : item.templateMessage
                }))
                this.loading = false
            })
        },
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId")
        this.getSmsManagement()
    },
};
</script>